export class TopListHistoryDataRequestModel {
    public config = '';
    public saveToMru = false;

    public retryCount: number = 0;
    //public retryMillisecondsThreshold: number = 600000; // 10 minutes, which basically disables retries 
    public retryMillisecondsThreshold: number = 2000; // retry after 2 seconds 
    public canceledRetryThreshold: number = 3;
    public isRetryRequest = false;

    public clone(){
        const clonedRequest = new TopListHistoryDataRequestModel();
        clonedRequest.config = this.config;
        clonedRequest.saveToMru = this.saveToMru;
        clonedRequest.retryCount = this.retryCount;
        clonedRequest.retryMillisecondsThreshold = this.retryMillisecondsThreshold;
        clonedRequest.canceledRetryThreshold = this.canceledRetryThreshold;
        clonedRequest.isRetryRequest = this.isRetryRequest;
        return clonedRequest;
    }
}